
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {switchMap, take, catchError} from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {ConfigService} from '../core/config.service';
import { environment } from '../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private inj: Injector,
              private oidcSecurityService: OidcSecurityService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (((environment.oidc.enable  === 'true') ? true : false)) {
      if (req.url.indexOf(environment.zuul_uri) != -1) {
        return this.oidcSecurityService.isAuthenticated().pipe(          
          switchMap((isAuthenticated) => {
            if(!isAuthenticated) {
              return this.oidcSecurityService.forceRefreshSession().pipe(
                switchMap(({accessToken}) => {
                  const copiedReq = req.clone({
                    headers: req.headers
                      .set(`Authorization`, `Bearer ${accessToken}`)
                  });
                  return next.handle(copiedReq);  
                })
              );
            } else {
              return this.oidcSecurityService.getAccessToken().pipe(
                switchMap((accessToken) => {
                  const copiedReq = req.clone({
                    headers: req.headers
                      .set(`Authorization`, `Bearer ${accessToken}`)
                  });
                  return next.handle(copiedReq);  
                })
              );
            }
          })
        );  
      } else {
        return next.handle(req);
      }
    } else {

      // Le richieste di token / refresh token non devono essere intercettate
      if (req.url.indexOf(ConfigService.URL_OAUTH) >= 0) {
        return next.handle(req);
      }

      const authService = this.inj.get(AuthService);

      return authService.getRefreshedToken().pipe(
        take(1),
        switchMap( (token) => {
          if (token) {
            const copiedReq = req.clone({
              headers: req.headers
                .set('Authorization', 'Bearer ' + token.access_token)
            });
            return next.handle(copiedReq);  
          }
          return next.handle(req);
        }));
      }
    }

}
